import { render, staticRenderFns } from "./appFoot.vue?vue&type=template&id=4ddc396b&scoped=true&"
import script from "./appFoot.vue?vue&type=script&lang=js&"
export * from "./appFoot.vue?vue&type=script&lang=js&"
import style0 from "./appFoot.vue?vue&type=style&index=0&id=4ddc396b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddc396b",
  null
  
)

export default component.exports